import { render, staticRenderFns } from "./Comissions.vue?vue&type=template&id=4ff7b249"
import script from "./Comissions.vue?vue&type=script&lang=js"
export * from "./Comissions.vue?vue&type=script&lang=js"
import style0 from "./styles/comissions.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports